import React from "react";
import {
  Box,
  Typography,
  Button,
  Card,
  CardMedia,
  useTheme,
  Grid,
} from "@mui/material";
import { useTranslation } from "react-i18next";

export default function EnergyLanding() {
  const theme = useTheme();
  const { t, i18n } = useTranslation();

  return (
    <Box
      sx={{
        fontFamily: "sans-serif",
        m: 3,
        direction: i18n.dir(), // RTL / LTR support
        textAlign: i18n.dir() === "rtl" ? "right" : "left",
      }}
    >
      {/* Hero Section */}
      <Box
        sx={{
          height: "100vh",
          position: "relative",
          borderRadius: "50px",
          overflow: "hidden",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          px: { xs: 4, md: 10 },
          color: "white",
        }}
      >
        {/* Background image */}
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundImage: 'url("image/img3.jpg")',
            backgroundSize: "cover",
            backgroundPosition: "center",
            zIndex: 1,
          }}
        />

        {/* Dark overlay */}
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            zIndex: 2,
          }}
        />

        {/* Hero Content */}
        <Box sx={{ position: "relative", zIndex: 3 }}>
          <Typography
            variant="h2"
            sx={{
              fontWeight: 600,
              fontSize: { xs: "2.5rem", md: "4rem" },
              lineHeight: 1.2,
            }}
          >
            {t("heroTitleLine1")}
            <br />
            {t("heroTitleLine2")}
          </Typography>

          <Box sx={{ display: "flex", gap: 2, mt: 4 }}>
           
          </Box>
        </Box>

        {/* Floating Project Card */}
        <Box
          sx={{
            position: "absolute",
            top: "15%",
            right: i18n.dir() === "rtl" ? "auto" : { xs: "5%", md: "8%" },
            left: i18n.dir() === "rtl" ? { xs: "5%", md: "8%" } : "auto",
            background: "rgba(255, 255, 255, 0.1)",
            backdropFilter: "blur(10px)",
            borderRadius: 4,
            p: 2,
            width: 220,
            boxShadow: "0 8px 24px rgba(0,0,0,0.2)",
            zIndex: 3,
          }}
        >
          <Card sx={{ background: "transparent", boxShadow: "none" }}>
            <CardMedia
              component="img"
              image="image/img1.jpg"
              alt="Windmill"
              sx={{ borderRadius: 2, height: 120, width: "100%" }}
            />
          </Card>
        </Box>
      </Box>

      {/* Overlay Card Section */}
      <Grid container>
        <Grid item xs={12} lg={6}></Grid>
        <Grid item xs={12} lg={6} sx={{ position: "relative" }}>
          <Card
            sx={{
              height: "203px",
              borderBottomRightRadius: "50px",
              borderTopLeftRadius: "50px",
              mt: "-202px",
              position: "relative",
              zIndex: 10,
              display: "flex",
              justifyContent: "space-around",
              alignItems: "center",
              textAlign: "center",
              px: 3,
              backgroundColor: "#fff",
              direction: i18n.dir(), // ensure content inside also respects direction
            }}
          >
            {[
              { value: "+4", label: t("stats.districts") },
              { value: "+15", label: t("stats.projects") },
              { value: "+546", label: t("stats.units") },
            ].map((item, index) => (
              <Box key={index} sx={{ px: 2 }}>
                <Typography
                  variant="h4"
                  sx={{ fontWeight: "bold", color: "dodgerblue" }}
                >
                  {item.value}
                </Typography>
                <Typography
                  variant="body2"
                  sx={{ fontSize: "14px", color: "#555" }}
                >
                  {item.label}
                </Typography>
              </Box>
            ))}
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
}
